module.exports = __webpack_public_path__ + "img/station-popup.99e5eb72.svg";